export class UsernameValidator {
    private regex: RegExp = /^(?:(?!oficial|official)[a-z0-9_]){2,30}$/
    validate(username: string): boolean {
        return this.regex.test(username)
    }

    errorMessage(): string {
        return 'Username must be between 2 and 30 characters long and can only contain lowercase letters, numbers and underscores. It cannot contain the words "oficial" or "official".'
    }
}